import axios from 'axios';
import Constants from './Constants';

const HTTP = axios.create({
  baseURL: Constants.BASE_URL,
  headers: {
    'Content-Type': Constants.CONTENT_TYPE,
    //'Authorization': "Bearer "
  }
})

export default HTTP;